const Whatsapp = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.835938"
        y="0.270508"
        width="36"
        height="36"
        rx="8"
        fill="#198953"
      />
      <g clip-path="url(#clip0_10958_88227)">
        <path
          d="M8.83594 28.2724C9.11298 27.4543 9.37964 26.6659 9.64693 25.8772C9.95263 24.9747 10.2605 24.0731 10.5606 23.169C10.5826 23.1021 10.5728 23.0034 10.5376 22.9424C9.50211 21.1618 9.06891 19.2458 9.2301 17.1985C9.56948 12.8891 12.8534 9.2581 17.137 8.44968C22.4024 7.45589 27.4261 10.7355 28.6029 15.9352C29.775 21.1133 26.4067 26.3821 21.1888 27.52C18.8122 28.0383 16.5404 27.7357 14.3848 26.6093C14.2887 26.559 14.2116 26.5659 14.119 26.5953C12.4174 27.1373 10.7155 27.6782 9.0135 28.219C8.9647 28.2346 8.91559 28.2484 8.83594 28.2724ZM11.3791 25.7844C12.4058 25.4586 13.3943 25.146 14.3816 24.8293C14.4748 24.7993 14.5441 24.8049 14.6294 24.8581C16.4938 26.0151 18.5084 26.3824 20.6633 25.9607C25.0719 25.0985 27.984 20.6519 26.9989 16.2975C26.0214 11.9772 21.8789 9.25153 17.4952 10.0443C13.9179 10.6914 11.132 13.7638 10.8672 17.3623C10.7246 19.2973 11.2066 21.0673 12.322 22.6629C12.3799 22.7458 12.3869 22.8114 12.3548 22.9043C12.1104 23.6129 11.8718 24.3238 11.6316 25.0338C11.5504 25.2735 11.4701 25.5136 11.3791 25.7844Z"
          fill="white"
        />
        <path
          d="M14.109 15.6623C14.1118 14.7742 14.4669 14.0477 15.1363 13.469C15.3396 13.2933 15.5798 13.2211 15.8512 13.2521C16.002 13.2693 16.1544 13.2815 16.3061 13.283C16.4573 13.2849 16.5715 13.3443 16.6465 13.4697C16.6994 13.5588 16.7453 13.6535 16.7819 13.7501C17.0205 14.3778 17.255 15.0071 17.4934 15.6348C17.5488 15.7805 17.5604 15.9284 17.4657 16.0528C17.255 16.3297 17.0416 16.6058 16.8092 16.8646C16.6131 17.0831 16.586 17.1704 16.729 17.4305C17.494 18.8222 18.5993 19.8476 20.0655 20.4844C20.2704 20.5735 20.3948 20.5566 20.545 20.3906C20.8217 20.0845 21.0937 19.7744 21.3616 19.4606C21.5159 19.2799 21.6163 19.242 21.8421 19.3233C21.9403 19.3586 22.0366 19.4012 22.1292 19.4496C22.7088 19.7525 23.2852 20.062 23.867 20.3606C24.0553 20.4572 24.1296 20.5919 24.1135 20.8004C24.0566 21.5366 23.7804 22.1303 23.09 22.4957C22.3999 22.8612 21.6919 23.0143 20.9281 22.7705C19.4783 22.3078 18.1076 21.7064 16.9962 20.6263C16.2762 19.9264 15.6548 19.1526 15.1126 18.3111C14.7811 17.7965 14.455 17.2798 14.2862 16.6877C14.1915 16.3544 14.1395 16.0093 14.0684 15.6695C14.0816 15.6673 14.0951 15.6648 14.109 15.6623Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_10958_88227">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(8.83594 8.27051)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Whatsapp;
